'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var flightDetails = {
    ARRIVAL: (0, _reactIntl.defineMessages)({
        ARRIVING_OVERLAND_PRE: {
            'id': 'formOverrides.flightDetails.ARRIVING_OVERLAND_PRE',
            'defaultMessage': 'Other (Before first day of tour)'
        },
        ARRIVING_OVERLAND_DOFT: {
            'id': 'formOverrides.flightDetails.ARRIVING_OVERLAND_DOFT',
            'defaultMessage': 'Other (On first day of tour)'
        },
        DECLINED_FORFEITED_TRANSFER: {
            'id': 'formOverrides.flightDetails.DECLINED_FORFEITED_TRANSFER',
            'defaultMessage': 'Declined/forfeited transfer'
        },
        NO_FLIGHTS: {
            'id': 'formOverrides.flightDetails.NO_FLIGHTS',
            'defaultMessage': 'Don\'t know (no flights booked)'
        },
        FLIGHT_NOT_FOUND: {
            'id': 'formOverrides.flightDetails.FLIGHT_NOT_FOUND',
            'defaultMessage': 'Flight not found'
        },
        PREVIOUS_TOUR_IN_CITY: {
            'id': 'formOverrides.flightDetails.PREVIOUS_TOUR_IN_CITY',
            'defaultMessage': 'Previous tour ends in start city'
        },
        ARRIVAL_PRE_THREE_WEEKS: {
            'id': 'formOverrides.flightDetails.ARRIVAL_PRE_THREE_WEEKS',
            'defaultMessage': 'Since you\'ve indicated you\'re arriving more than 3 weeks prior to joining us, please indicate you\'re arriving \'other - First day of tour\''
        }
    }),
    DEPARTURE: (0, _reactIntl.defineMessages)({
        DEPART_OVERLAND_POST_DOLT: {
            'id': 'formOverrides.flightDetails.DEPART_OVERLAND_POST_DOLT',
            'defaultMessage': 'Other (After last day of tour)'
        },
        DEPART_OVERLAND_LAST_DAY: {
            'id': 'formOverrides.flightDetails.DEPART_OVERLAND_LAST_DAY',
            'defaultMessage': 'Other (On last day of tour)'
        },
        NO_FLIGHTS: {
            'id': 'formOverrides.flightDetails.NO_FLIGHTS',
            'defaultMessage': 'Don\'t know (no flights booked)'
        },
        FLIGHT_NOT_FOUND: {
            'id': 'formOverrides.flightDetails.FLIGHT_NOT_FOUND',
            'defaultMessage': 'Flight not found'
        }
    })
};

exports.default = flightDetails;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOverrides/flightDetails.js
// module id = 1381
// module chunks = 0